import { GasModel } from '../models/gas';
import { GasMapModel } from '../models/gas-map';
import { ReductionChartModel } from '../models/reduction-chart';

import BaseApiService from './base-api-service';

export enum GasMapType {
  GasDayAheadP = 'GasDayAheadP',
  GasDayAheadM = 'GasDayAheadM',
  GasMonthP = 'GasMonthP',
  GasMonthM = 'GasMonthM',
}

export default class GasService extends BaseApiService {
  public async getGas(): Promise<GasModel> {
    const response = await this.getResource('/GetGas/Daily_Market_Total');

    return response;
  }

  public async getGasMap(type: GasMapType): Promise<GasMapModel> {
    const response = await this.getResource(`/GetMapGas?typeMap=${type}`);

    return response;
  }

  public async getReductionChart(): Promise<Array<ReductionChartModel>> {
    const response = await this.getResource(`/ReductionGraph`);

    return response;
  }
}
